// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__pyBCL","footer":"Footer_footer__3NAON"};